import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProductDescWrapper = styled.div`
  font-size: 13px;
  .resultList &,
  .resultGrid & {
    padding: 15px 20px;
    background: #eee;
    border-radius: 2px;
    position: relative;
  }

  .resultList & {
    position: relative;
    clear: both;
    margin-top: 10px;
    /* width: calc(100% - 40px); */
  }

  .resultGrid & {
    margin: 0 10px 10px;
    ${({ belowSponsoredGrid }) => belowSponsoredGrid && 'margin: 0; bottom: 1px; z-index: 1;'}
  }
`;

const ProductDescArrow = styled.span`
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  position: absolute;
  transform: rotate(45deg);
  background: #eee;
  display: none;

  .resultList & {
    left: 70px;
    top: -20px;
    z-index: 1;
    display: block;
  }

  @media ${({ theme }) => theme.breakpoints.touch} {
    .resultList & {
      display: block;
      left: 35px;
    }
  }
`;

const ProductDescText = styled.span`
  .resultList & {
    position: relative;
    z-index: 2;
  }
`;

const ProductDescLink = styled.a`
  .resultList ${ProductDescWrapper} &,
  .resultGrid ${ProductDescWrapper} & {
    display: inline-block;
    padding-left: 10px;
    color: #161b7a;
    cursor: pointer;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  }
`;

function ProductBriefDescription(props) {
  return (
    <ProductDescWrapper
      belowSponsoredGrid={props.belowSponsoredGrid}
      className={props.icons ? 'with-stickers' : ''}
    >
      <ProductDescArrow className={'product-desc-arrow'} />
      <ProductDescText>{props.descriptionShortened}</ProductDescText>
      <ProductDescLink href={props.link}>{props.productDescriptionLinkTranslation}</ProductDescLink>
    </ProductDescWrapper>
  );
}

ProductBriefDescription.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  descriptionShortened: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  productDescriptionLinkTranslation: PropTypes.string.isRequired,
  belowSponsoredGrid: PropTypes.bool
};

ProductBriefDescription.defaultProps = {
  icons: null,
  belowSponsoredGrid: false
};

export { ProductBriefDescription, ProductDescArrow, ProductDescText, ProductDescLink };
